import { Injectable } from '@angular/core';
import { AssetDto, GalleryDto } from '@picflow/types';

export interface PrintData {
  gallery: GalleryDto;
  assets: AssetDto[];
  favorites: boolean;
  status: boolean;
  color_labels: boolean;
  filename: boolean;
  thumbnailSize: 'small' | 'medium' | 'large';
}

@Injectable({
  providedIn: 'root',
})
export class PrintOverviewService {
  public data: PrintData;

  print(data: PrintData) {
    this.data = data;
  }

  finish() {
    this.data = undefined;
  }
}
